import { useParams, useSearchParams } from "react-router-dom";
import DeploymentDetail, { type DeploymentDetailStep } from "@/features/admin/deployment-detail";

const DETAIL_STEPS: DeploymentDetailStep[] = ["bootstrap", "acceptance", "operate", "history"];

export default function Page() {
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const stepParam = searchParams.get("step") ?? undefined;
  const initialStep: DeploymentDetailStep = DETAIL_STEPS.includes(stepParam as DeploymentDetailStep)
    ? (stepParam as DeploymentDetailStep)
    : "bootstrap";

  return <DeploymentDetail id={id!.toUpperCase()} initialStep={initialStep} />;
}
